import React, { useRef } from "react";
import "./infosquare.css";
import { CircularProgress } from "react-cssfx-loading";

function Infosquare({ title, data, loading, type }) {
  return (
    <div className="info-square shadow-sm"  style={type == 3 ? {backgroundColor: "blue"} : {}}>
      {loading ? (
        <CircularProgress />
      ) : (
        <span
        
          className={`info-square-data ${
            title == "Concluídos"
              ? "green"
              : title == "Criados" || title == "Parceiros"
              ? "blue"
              : type == 3 ? "white" : "red"
          }`}
        >
          {type == 1 || type == 3 ? data : `${data}%`}
        </span>
      )}
      {type == 1 && (
        <span className="info-square-data-label">
          Chamados
          <br />
          <b>{title}</b>
        </span>
      )}
      {type == 2 && (
        <span 
        className="info-square-data-label">
          Produtividade <br />
          <b>{title}</b>
        </span>
      )}
      {type == 3 && (
        <span 
        className="info-square-data-label" 
        style={type == 3 ? {color: "#FFF"} : {}}>
          Dias de Publicação sem<b> {title}</b>
        </span>
      )}
    </div>
  );
}

export default Infosquare;
